module.exports = __webpack_public_path__ + "img/1728610147826-WhatsApp Image 2024-10-11 at 09.28.00.jpeg.c7867e7f.webp";